// extracted by mini-css-extract-plugin
export var closeButton = "_ex-1";
export var closeX = "_ex-3";
export var container = "_ex-0";
export var image = "_ex-2";